var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-skeleton"},[_c('SkeletonAnimation',[_c('PartItem',{attrs:{"styles":_vm.banner}})],1),_c('div',{staticClass:"store-info"},[_c('div',{staticClass:"max-width store-flex"},[_c('SkeletonAnimation',[_c('div',{staticClass:"common-flex"},[_c('div',{staticClass:"common-flex_right"},[_c('PartItem',{attrs:{"styles":{
                width: '578px',
                height: '20px',
                'border-radius': '4px',
                'margin-bottom': '20px',
              }}}),_c('PartItem',{attrs:{"styles":{
                width: '400px',
                height: '20px',
                'border-radius': '4px',
              }}})],1)])])],1)]),_c('div',{staticClass:"store-content"},[_c('SkeletonAnimation',[_c('div',{staticClass:"store-content__infos max-width"},[_c('div',{staticClass:"common-left"},[_c('div',{staticClass:"store-info__sku"},_vm._l((4),function(item){return _c('PartItem',{key:item,attrs:{"styles":{
                width: '155px',
                height: '20px',
                'border-radius': '4px',
                'margin-bottom': '28px',
              }}})}),1)]),_c('div',{staticClass:"common-right"},[_c('div',{staticClass:"common-right_title"},[_c('PartItem',{key:_vm.item,attrs:{"styles":{
                width: '182px',
                height: '20px',
                'border-radius': '4px',
                'margin-bottom': '20px',
              }}})],1),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1'),_c('Store1')],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }